import commonGlobals from '@opendoor/shared-fe/build/commonGlobals';
import { getRailsEnv } from '@opendoor/shared-fe/build/railsEnv';

declare let process: any;

const odRailsEnv = getRailsEnv();
const secrets = commonGlobals[odRailsEnv];

export const COOKIE_KEY = window.location.hostname === 'localhost' ? 'XSRF-TOKEN' : 'XSRF-G-TOKEN';
export const RAILS_ENV = odRailsEnv;
export const FRONTEND_RELEASE_SHA = process.env.REACT_APP_GIT_SHA;
// Google API calls use this project for billing and API keys:
// https://console.cloud.google.com/apis/credentials?project=val-tool-3-1495755979574&organizationId=727186813944
export const GOOGLE_MAPS_API_KEY = secrets.googleMaps;
export const SEGMENT_MARKET_JS_KEY = secrets.segment;
export const PUSHER_URL = secrets.pusherUrl;
export const WEB_API_URL = secrets.webApiUrl;
export const FACEBOOK_APP_ID = secrets.facebookAppID;
export const GOOGLE_CLIENT_ID = secrets.googleClientID;
export const PARTNERSHIP_BFF_URL = secrets.partnerBffUrl;

export const OD_HOMEPAGE_URL =
  RAILS_ENV === 'production' ? 'https://www.opendoor.com' : 'https://demo.simplersell.com';
